import React from 'react';

type Props = {
	payload: {
		genericChildren: boolean;
	};
};

export const GenericDescription: React.FC<React.PropsWithChildren<Props>> = ({children, payload}) => {
	return <>{payload?.genericChildren ? null : children}</>;
};
